import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog, DialogProps } from '@modernloop/shared/components';

type DeleteNoteModalProps = Pick<DialogProps, 'open' | 'onClose'> & {
  onSubmit: () => void;
};

const DeleteNoteModal: FC<DeleteNoteModalProps> = ({ onSubmit, onClose, open }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('hiring-dashboard-common:common.notes.deleteComment')}
      subTitle={t('hiring-dashboard-common:common.notes.deleteWarning')}
      cancelOptions={{ onClick: (e) => onClose?.(e), label: t('hiring-dashboard-common:common.cancel') }}
      submitOptions={{
        onClick: () => {
          onSubmit();
        },
        isDangerous: true,
        label: t('hiring-dashboard-common:common.delete'),
      }}
    >
      <></>
    </Dialog>
  );
};

export default DeleteNoteModal;
